import { useCustomToast } from "hooks/toast";
import React, { useContext } from "react";
import { useApi } from "hooks/api";
import { useNavigate } from "react-router";

const Context = React.createContext();

export const ContextWrapper = ({ children }) => {
  const { showToast } = useCustomToast();
  const api = useApi({ showToast });
  const navigate = useNavigate();
  const contextData = { showToast, api, navigate };

  return <Context.Provider value={contextData}>{children}</Context.Provider>;
};

export const usePlatformContext = () => {
  return useContext(Context);
};
